import { setActiveDate, getChpoContext, loadContext, invalidateChpoContext } from './http';
import { getShiftDate } from './shiftDate';

function normalizeDateInput(dateInput) {
  if (dateInput instanceof Date) {
    const d = dateInput;
    const two = (n) => (n < 10 ? `0${n}` : String(n));
    return `${d.getFullYear()}-${two(d.getMonth() + 1)}-${two(d.getDate())}`;
  }
  if (typeof dateInput === 'string') {
    return dateInput.trim();
  }
  throw new Error('Дата должна быть строкой YYYY-MM-DD или объектом Date');
}

export async function checkOrCreateChpoByDate(dateInput) {
  const dateISO = normalizeDateInput(dateInput);
  const re = /^\d{4}-\d{2}-\d{2}$/;
  if (!re.test(dateISO)) {
    throw new Error(`Некорректный формат даты: "${dateISO}". Ожидается YYYY-MM-DD.`);
  }
  // Устанавливаем активную дату, чтобы последующие запросы шли в этот контекст
  setActiveDate(dateISO);

  // Используем loadContext для дедупликации и кэширования
  return loadContext('chpo', dateISO);
}

export function setChpoActiveDate(date) {
  setActiveDate(date);
}

// === Логика вычисления даты CHPO ===
// По ТЗ «Рабочие задачи» блок 5: армейская смена идёт 20:00 → 20:00 следующего дня.
// План охраны составляется НА следующую (относительно текущей) смену.
// getShiftDate() возвращает дату текущей смены; +1 сутки — план на завтра.
export function computeChpoDate(base = new Date()) {
  const now = (base instanceof Date) ? base : new Date();
  const shift = getShiftDate(now); // 'YYYY-MM-DD'
  const [y, m, d] = shift.split('-').map(Number);
  const target = new Date(y, m - 1, d + 1);
  const two = (n) => (n < 10 ? `0${n}` : String(n));
  return `${target.getFullYear()}-${two(target.getMonth() + 1)}-${two(target.getDate())}`;
}

// Утилита: вернуть текущую вычисленную дату CHPO и установить её как активную
export async function ensureTodayChpoContext() {
  const dateISO = computeChpoDate();
  setActiveDate(dateISO);
  return checkOrCreateChpoByDate(dateISO);
}

export function refreshTodayChpoContext() {
  const dateISO = computeChpoDate();
  invalidateChpoContext(dateISO);
}
